import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Das from './pages/DasManual';
import Main from './pages/Main';
import Login from './pages/Login';
import PrivateRoute from './PrivateRoutes';
import RecuperarSenha from './pages/RecuperarSenha';
import NovaSenha from './pages/NovaSenha';
import ServicosContratados from './pages/ServicosContratados';
import Cobrancas from './pages/Cobrancas';
import Assinaturas from './pages/Assinaturas';
import CadastrarEmpresaUsuario from './pages/CadastrarEmpresaUsuario';
import Cnd from './pages/Cnd';
import Cliente from './pages/Clientes';
import ClienteDetalhado from './pages/Clientes/detalhados';
import PlanosAssinatura from './pages/PlanosAssinatura';
import FormaPagamento from './pages/FormasDePagamento';
import Servicos from './pages/Servicos';
import EnviarEmail from './pages/EnviarEmail';
import DocumentoUsuario from './pages/DocumentoUsuario';
import Atividades from './pages/Atividades';
import Mensal from './pages/Atividades/mensal';
import Anual from './pages/Atividades/anual';
import NotificarUsuario from './pages/NotificarUsuario';
import Validacao from './pages/Validacao';
import Perfil from './pages/Perfil';
import Acessos from './pages/Acessos';
import Usuario from './pages/Usuario';
import Receita from './pages/Receita';
import LancementoReceita from './pages/Receita/lancamento';
import Importacao from './pages/Importação';
import HistoricoEnvioEmail from './pages/HistoricoEnvioEmail';
import ServicosCustom from './pages/ServicosCustom';
import Cupons from './pages/Cupons';
import Tributos from './pages/Tributos';
import ConfiguracaoNotas from './pages/ConfiguracaoNotas';
import NotasXmei from './pages/NotasXmei';
import ParametrizacaoDescontos from './pages/DescontoIndicacao/parametrizacao';
import DescontoIndicacao from './pages/DescontoIndicacao';
import Relatorios from './pages/Relatorios';
import HistoricoCupons from './pages/Cupons/historico';
import Pagamentos from './pages/Pagamentos';
import Tour from './pages/Tour';
import Faturamento from './pages/Faturamento';
import Planilha from './pages/Planilha';
import GuiaTributos from './pages/GuiaTributos';
import IntencaoAssinatura from './pages/IntencaoAssinatura';
import Guias from './pages/Guias';
import EmailPrefeitura from './pages/EmailPrefeitura';
import SolicitacaoCND from './pages/SolicitacaoCND';
import ClientesTron from './pages/ClientesTron';
import RegistroBasico from './pages/SignupApp';
import ContratarAbertura from './pages/SignupApp/ContratarAbertura';
import ContratarAssinatura from './pages/SignupApp/ContratarAssinatura';
import Pagamento from './pages/SignupApp/Pagamento';
import PagamentoBoleto from './pages/SignupApp/PagamentoComBoleto';
import PagamentoCartao from './pages/SignupApp/PagamentoComCartao';
import PagamentoPixAutomatico from './pages/SignupApp/PagamentoComPixAutomatico';
import PagamentoPixSignup from './pages/SignupApp/PagamentoComPix';
import CaracteristicasPrefeitura from './pages/CaracteristicasPrefeitura';
import DocumentosIRPF from './pages/DocumentosIRPF';
import DadosPessoais from './modules/usuario/pages/dadosPessoais';
import EnderecoUsuario from './modules/usuario/pages/endereco';
import EmpresaUsuario from './modules/usuario/pages/empresa';
import EmpresaPrimeiroAcesso from './modules/usuario/pages/empresaPrimeiroAcesso';
import AssinaturaUsuario from './modules/usuario/pages/assinatura';
import MeiosPagamento from './modules/usuario/pages/pagamento';
import PagamentoComCartao from './modules/pagamento/PagamentoComCartao';
import PagamentoComBoleto from './modules/pagamento/PagamentoComBoleto';
import PagamentoComPix from './modules/pagamento/PagamentoComPix';
import ServicosUsuario from './modules/servicos';
import StatusServicos from './pages/StatusServicos';
import OutrosTributosComponent from 'src/pages/OutrosTributos';

export default function Routes() {
  return (
    <BrowserRouter>
      <Switch>
        <Route
          path="/signup/:company/:cnpj?"
          exact
          component={RegistroBasico}
        />

        <Route
          path="/open"
          render={(props) => <ContratarAbertura {...props} />}
        />
        <Route
          path="/signature"
          render={(props) => <ContratarAssinatura {...props} />}
        />
        <Route path="/payment" render={(props) => <Pagamento {...props} />} />
        <Route
          path="/payment-boleto"
          render={(props) => <PagamentoBoleto {...props} />}
        />
        <Route
          path="/payment-card"
          render={(props) => <PagamentoCartao {...props} />}
        />
        <Route
          path="/payment-pix-automatico"
          render={(props) => <PagamentoPixAutomatico {...props} />}
        />
        <Route
          path="/payment-pix"
          render={(props) => <PagamentoPixSignup {...props} />}
        />
        <Route path="/login" exact component={Login} />
        <Route path="/recuperarsenha" exact component={RecuperarSenha} />
        <Route path="/novasenha" exact component={NovaSenha} />
        <Route
          path="/empresa-primeiro"
          exact
          component={EmpresaPrimeiroAcesso}
        />

        <Main>
          <PrivateRoute
            component={({ match }) => (
              <div>
                <PrivateRoute
                  path="/servicosUsuario"
                  component={ServicosUsuario}
                />
                <Route
                  path="/statusServicos"
                  exact
                  component={StatusServicos}
                />

                <PrivateRoute path="/dashboard" exact component={Relatorios} />
                <PrivateRoute
                  path="/PagamentoComCartao"
                  exact
                  component={PagamentoComCartao}
                />
                <PrivateRoute
                  path="/PagamentoComBoleto"
                  exact
                  component={PagamentoComBoleto}
                />
                <PrivateRoute
                  path="/PagamentoComPix"
                  exact
                  component={PagamentoComPix}
                />
                <PrivateRoute
                  path="/PagamentoComPixAutomatico"
                  exact
                  component={PagamentoPixAutomatico}
                />
                <PrivateRoute
                  path="/servicoscontratados"
                  exact
                  component={ServicosContratados}
                />
                <PrivateRoute path="/cobrancas" exact component={Cobrancas} />
                <PrivateRoute
                  path="/assinaturas"
                  exact
                  component={Assinaturas}
                />
                <PrivateRoute
                  path="/empresas"
                  exact
                  component={CadastrarEmpresaUsuario}
                />
                <PrivateRoute path="/das" exact component={Das} />
                <PrivateRoute
                  path="/outros-tributos"
                  exact
                  component={OutrosTributosComponent}
                />
                <PrivateRoute path="/cnd" exact component={Cnd} />
                <PrivateRoute path="/clientes" exact component={Cliente} />
                <PrivateRoute
                  path="/clientesdetalhados"
                  exact
                  component={ClienteDetalhado}
                />
                <PrivateRoute
                  path="/planoassinatura"
                  exact
                  component={PlanosAssinatura}
                />
                <PrivateRoute
                  path="/formapagamento"
                  exact
                  component={FormaPagamento}
                />
                <PrivateRoute path="/servicos" exact component={Servicos} />
                <PrivateRoute
                  path="/enviarEmail"
                  exact
                  component={EnviarEmail}
                />
                <PrivateRoute
                  path="/documentosUsuario"
                  exact
                  component={DocumentoUsuario}
                />
                <PrivateRoute path="/atividades" exact component={Atividades} />
                <PrivateRoute
                  path="/atividades/mensal/:id/:mes/:ano"
                  exact
                  component={Mensal}
                />
                <PrivateRoute
                  path="/atividades/anual/:id/:ano"
                  exact
                  component={Anual}
                />
                <PrivateRoute
                  path="/notificarUsuario"
                  exact
                  component={NotificarUsuario}
                />
                <PrivateRoute
                  path="/historicoenvioemail"
                  exact
                  component={HistoricoEnvioEmail}
                />
                <PrivateRoute path="/validacao" exact component={Validacao} />
                <PrivateRoute path="/perfil" exact component={Perfil} />
                <PrivateRoute path="/acessos" exact component={Acessos} />
                <PrivateRoute path="/usuarios" exact component={Usuario} />
                <PrivateRoute
                  path="/listarReceitas"
                  exact
                  component={Receita}
                />
                <PrivateRoute
                  path="/lancamentoReceita"
                  exact
                  component={LancementoReceita}
                />
                <PrivateRoute
                  path="/importacaoPlanilha"
                  exact
                  component={Importacao}
                />
                <PrivateRoute
                  path="/servicosCustomizaveis"
                  exact
                  component={ServicosCustom}
                />
                <PrivateRoute path="/cupons" exact component={Cupons} />
                <PrivateRoute path="/tributos" exact component={Tributos} />
                <PrivateRoute
                  path="/configuracaonotas"
                  exact
                  component={ConfiguracaoNotas}
                />
                <PrivateRoute path="/notasxmei" exact component={NotasXmei} />
                <PrivateRoute
                  path="/parametrizacaodescontos"
                  exact
                  component={ParametrizacaoDescontos}
                />
                <PrivateRoute
                  path="/listarindicacao"
                  exact
                  component={DescontoIndicacao}
                />
                <PrivateRoute
                  path="/historicocupom"
                  exact
                  component={HistoricoCupons}
                />
                <PrivateRoute path="/pagamentos" exact component={Pagamentos} />
                <PrivateRoute path="/tour" exact component={Tour} />
                <PrivateRoute
                  path="/financeiro"
                  exact
                  component={Faturamento}
                />
                <PrivateRoute path="/planilhas" exact component={Planilha} />
                <PrivateRoute
                  path="/guiatributos"
                  exact
                  component={GuiaTributos}
                />
                <PrivateRoute
                  path="/intencaoassinatura"
                  exact
                  component={IntencaoAssinatura}
                />
                <PrivateRoute path="/guias" exact component={Guias} />
                <PrivateRoute
                  path="/emailprefeitura"
                  exact
                  component={EmailPrefeitura}
                />
                <PrivateRoute
                  path="/requisicaoCND"
                  exact
                  component={SolicitacaoCND}
                />
                <PrivateRoute
                  path="/dadosClientes"
                  exact
                  component={ClientesTron}
                />
                <PrivateRoute
                  path="/caracteristicasprefeitura"
                  exact
                  component={CaracteristicasPrefeitura}
                />
                <PrivateRoute
                  path="/documentosIRPF"
                  exact
                  component={DocumentosIRPF}
                />

                <PrivateRoute
                  path="/usuarioDados"
                  exact
                  component={DadosPessoais}
                />

                <PrivateRoute
                  path="/usuarioEndereco"
                  exact
                  component={EnderecoUsuario}
                />

                <PrivateRoute
                  path="/usuarioEmpresa"
                  exact
                  component={EmpresaUsuario}
                />

                <PrivateRoute
                  path="/usuarioAssinatura"
                  exact
                  component={AssinaturaUsuario}
                />

                <PrivateRoute
                  path="/meiosPagamento"
                  exact
                  component={MeiosPagamento}
                />
              </div>
            )}
          />
        </Main>
      </Switch>
    </BrowserRouter>
  );
}
